/**
 * useMapaGeo — fetcha /api/mapa/geo (mapa + totais por métrica) para a fonte, a
 * métrica e os filtros ativos. Re-busca quando qualquer um deles, o período ou o
 * cliente mudam; mudanças rápidas nos filtros são agrupadas (debounce).
 */

import { useState, useEffect, useRef, useCallback } from 'react'
import { getMapaGeo } from '../db/api.js'

const DEBOUNCE_MS = 250

export function useMapaGeo(startDate, endDate, clientId, source, metric, filters) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  // Chave estável: arrays novos com o mesmo conteúdo não re-disparam a busca.
  const filtersKey = JSON.stringify(filters || {})
  const context = JSON.stringify([startDate, endDate, clientId, source, metric, filtersKey])

  const refetch = useCallback(async () => {
    if (!startDate || !endDate) return
    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)
    try {
      const result = await getMapaGeo({
        startDate, endDate, clientId, source, metric, filters: JSON.parse(filtersKey),
      })
      if (requestId !== requestIdRef.current) return
      setData({ context, result })
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('[useMapaGeo] fetch error:', err)
      setError(err.message || 'Erro ao carregar o mapa')
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [startDate, endDate, clientId, source, metric, filtersKey, context])

  useEffect(() => {
    const t = setTimeout(refetch, DEBOUNCE_MS)
    return () => { clearTimeout(t); requestIdRef.current += 1 }
  }, [refetch])

  return { data: data?.context === context ? data.result : null, loading, error, refetch }
}
